import * as React from 'react';

function PlaceholderRegistrationCertificateFront(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg id="registration-front-placeholder" viewBox="0 0 800 500" {...props}>
			<g id="registration-front-placeholder-original">
				<switch>
					<g>
						<path opacity={0.2} fill="currentColor" d="M.177.505h799.599v499.453H.177z" />
						<path
							opacity={0.4}
							fill="currentColor"
							d="M650.943 418.721H148.39c-12.699 0-22.994-10.295-22.994-22.994V97.795c0-12.699 10.295-22.994 22.994-22.994h502.553c12.699 0 22.994 10.295 22.994 22.994v297.932c0 12.699-10.295 22.994-22.994 22.994z"
						/>
						<path
							opacity={0.4}
							fill="currentColor"
							d="M154.514 90.35h115.608v75.987H154.514zM290.064 141.37h311.143v24.967H290.064zM290.064 90.35h257.969v11.398H290.064zM519.042 186.962h122.121v16.283H519.042zM519.042 209.758h122.121v16.283H519.042zM226.943 188.047h68.79v10.312h-68.79zM358.864 188.047h85.171v10.312h-85.171zM226.943 206.501h37.979v10.312h-37.979zM226.943 221.156h150.715v10.312H226.943zM226.943 268.919h188.334v10.312H226.943zM186.862 268.919h28.441v10.312h-28.441zM186.862 221.156h28.441v10.312h-28.441zM186.862 300.399h28.441v10.312h-28.441zM186.862 316.682h28.441v10.312h-28.441zM186.862 364.445h28.441v10.312h-28.441zM186.862 394.297h28.441v10.312h-28.441zM186.862 206.501h28.441v10.312h-28.441zM186.862 189.675h15.686v10.312h-15.686zM226.943 284.659h98.004v10.312h-98.004z"
						/>
						<path fill="none" d="M226.672 234.725h32.837v14.112h-32.837z" />
						<text
							transform="translate(226.672 246.607)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M226.672 251.822h32.837v14.112h-32.837z" />
						<text
							transform="translate(226.672 263.704)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M226.672 298.499h32.837v14.112h-32.837z" />
						<text
							transform="translate(226.672 310.38)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M226.672 314.782h32.837v14.112h-32.837z" />
						<text
							transform="translate(226.672 326.665)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M226.672 331.065h32.837v14.112h-32.837z" />
						<text
							transform="translate(226.672 342.948)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M226.672 345.177h32.837v14.112h-32.837z" />
						<text
							transform="translate(226.672 357.06)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M226.672 362.545h32.837v14.112h-32.837z" />
						<text
							transform="translate(226.672 374.427)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M226.672 376.657h32.837v14.112h-32.837z" />
						<text
							transform="translate(226.672 388.539)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M226.672 392.397h32.837v14.112h-32.837z" />
						<text
							transform="translate(226.672 404.28)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
					</g>
				</switch>
			</g>
		</svg>
	);
}

export const MemoPlaceholderRegistrationCertificateFront = React.memo(
	PlaceholderRegistrationCertificateFront
);
